<template>
    <div class="row h-100 no-gutters">
        <div class="auth-form mx-auto my-auto col-md-5 col-lg-3">
            <div class="card">
                <div class="card-body"><!----> <!---->
                    <h1 style="text-align: center"><img id="main-logo" class="d-inline-block align-top mr-1" style="max-width: 100px;" src="@/assets/images/kf-logo.png" alt="Shards Dashboard"></h1>
                    <form @submit="login">
                        <div class="form-group">
                            <label>Adres e-mail</label>
                            <d-input
                                    v-model="email"
                                    name="email"
                                    type="email"
                                    @input="clearError('email')"
                                    :class="{'is-invalid' : lar_errors.has('email')}"
                                    placeholder="Twój adres e-mail" />
                            <div class="invalid-feedback" v-text="lar_errors.get('email')"></div>
                        </div>
                        <div class="form-group">
                            <label>Hasło</label>
                            <d-input
                                    v-model="password"
                                    name="password"
                                    type="password"
                                    autocomplete="off"
                                    @input="clearError('password')"
                                    :class="{'is-invalid' : lar_errors.has('password')}"
                                    placeholder="********" />
                            <div class="invalid-feedback" v-text="lar_errors.get('password')"></div>
                        </div>
                        <p class="text-danger" v-if="auth_error">Błąd autoryzacji</p>
                        <button type="submit" :class="{isLoading: submitting}" @click.prevent="login" class="btn btn-pill btn-accent d-table mx-auto">Zaloguj</button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import LarErrors from '../helpers/Errors';

    export default {
        name: "Login",
        components: {
            LarErrors
        },
        data(){
            return{
                auth_error: false,
                submitting: false,
                lar_errors: LarErrors,
                email: '',
                password: '',
            }
        },
        methods: {
            clearError(){
              this.auth_error = false;
            },
            login(){
                this.submitting = true;
                axios.post('login', {
                    email: this.email,
                    password: this.password
                }).then(response => {
                    this.submitting = false;
                    this.$localStorage.set('token', response.data.token);
                    axios.defaults.headers.common = {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ` + response.data.token
                    };
                    this.$nextTick(function () {
                        this.$router.push({name: 'dashboard'});
                    })
                }).catch((error) =>{
                    this.submitting = false;
                    this.auth_error = true;
                })
            }
        }
    }
</script>

<style scoped>

</style>
